import { connect } from 'react-redux';

import { actions } from '../actions/attachmentsPreviewModal';
import AttachmentsPreviewModal from '../components/AttachmentsPreviewModal';

const {
  attachmentsPreviewModalClose,
  attachmentsPreviewModalNext,
  attachmentsPreviewModalPrevious,
} = actions;

const mapStateToProps = (state: any) => {
  return {
    fileName: state.attachmentsPreviewModal.fileName,
    url: state.attachmentsPreviewModal.url,
    attachments: state.attachmentsPreviewModal.attachments,
    currentIndex: state.attachmentsPreviewModal.currentIndex,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    closeModal: () => dispatch(attachmentsPreviewModalClose()),
    goToNext: () => dispatch(attachmentsPreviewModalNext()),
    goToPrevious: () => dispatch(attachmentsPreviewModalPrevious()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AttachmentsPreviewModal);
